import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import Icon, { ICON_SIZE_EXTRA_SMALL } from '@divvy-web/skylab.icon'
import TextLink from '@divvy-web/skylab.textlink'

import styles from './styles.module.scss'

export interface MarketingLinkProps {
  text: React.ReactNode
  href: string
  onClick?: () => void
}

const MarketingLink = ({ text, href, onClick }: MarketingLinkProps) => {
  const [getClassName, makeTestId] = useNameFormatter('MarketingLink')

  return (
    <div
      className={styles[getClassName('')]}
      data-testid={makeTestId('')}
    >
      <TextLink
        isDark
        className={styles[getClassName('link')]}
        href={href}
        target='_blank'
        onClick={onClick} // on click is for sending web tracking event only
      >
        {text}
        <Icon
          className={styles[getClassName('icon')]}
          name='double-chevron-right'
          size={ICON_SIZE_EXTRA_SMALL}
        />
      </TextLink>
    </div>
  )
}

export default MarketingLink
